import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { RankList } from '../../components/cmsRankList';
import * as appConstants from 'util/appConstants';
import PrimusHandler from 'api/primusHandler';
import Container from '../../components/cmsContainer';
import './result.css';

class Result extends Component {
  state = {
    rankList: [],
    loading: true,
    status: appConstants.cmsMessages.loading,
    isTournament: false,
    contestDetails: null,
    isSessionRunning: true,
  };

  componentDidMount() {
    if (this.props.history.location.state.isTournament) {
      this.setState({ isTournament: true, contestDetails: this.props.history.location.state.contest });
    } else {
      this.setState({ isTournament: false });
    }
    if (this.props.history.location.state) {
      this.setState({ loading: true });
      if (this.props.history.location.state.isTournament) {
        PrimusHandler.sendRequest({
          _handler: 'load-tournament-leaderboard',
          _id: this.props.history.location.state.contestId,
          isReact: true,
        });
      } else {
        PrimusHandler.sendRequest({
          _handler: 'load-challenge-rankList',
          _id: this.props.history.location.state.contestId,
          isReact: true,
        });
      }
    } else {
      this.setState({ loading: false, status: appConstants.cmsMessages.noResults });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.isTournament) {
      if (nextProps.tournament_rankList && nextProps.tournament_rankList.data.length) {
        this.setState({
          rankList: nextProps.tournament_rankList.data,
          isSessionRunning: nextProps.tournament_rankList.isSessionRunning,
          loading: false,
          status: appConstants.cmsMessages.loading,
        });
      } else {
        this.setState({ rankList: [], loading: false, status: appConstants.cmsMessages.noResults });
      }
      if (nextProps.cron_details && nextProps.cron_details.data && nextProps.cron_details.data.started) {
        toast.success('Cron has started');
        this.setState({
          isSessionRunning: true,
        });
      }
    } else {
      if (nextProps.challenge_rankList && nextProps.challenge_rankList.data.length) {
        this.setState({
          rankList: nextProps.challenge_rankList.data,
          loading: false,
          status: appConstants.cmsMessages.loading,
        });
      } else {
        this.setState({ rankList: [], loading: false, status: appConstants.cmsMessages.noResults });
      }
    }
  }

  runTournament() {
    PrimusHandler.sendRequest(
      {
        _handler: 'run-tournament',
        contest: this.props.history.location.state.contestId,
        attempts: 5,
        roundCount: 5,
      },
      true
    ); // TODO: Need to work on this how we will handle static data
  }

  runTournament2() {
    PrimusHandler.sendRequest(
      {
        _handler: 'run-tournament',
        contest: this.props.history.location.state.contestId,
        attempts: 5,
        roundCount: 5,
        rankedMatching: true,
      },
      true
    ); // TODO: Need to work on this how we will handle static data
  }

  render() {
    return (
      <Container
        history={this.props.history}
        disabled={!this.state.rankList.length || this.state.isSessionRunning}
        heading="Results"
        buttonText={this.state.isTournament ? 'Run Tournament' : null}
        onClick={() => this.runTournament()}
        onClick2={() => this.runTournament2()}
      >
        {this.state.loading ? (
          <center className="noResults">{this.state.status}</center>
        ) : this.state.rankList.length ? (
          <RankList
            isTournament={this.state.isTournament}
            history={this.props.history}
            contestId={this.props.history.location.state.contestId}
            rankList={this.state.rankList}
          />
        ) : (
          <center className="noResults">{this.state.status}</center>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    challenge_rankList: state.data['load-challenge-rankList'],
    tournament_rankList: state.data['load-tournament-leaderboard'],
    cron_details: state.data['run-tournament'],
  };
};

export default connect(mapStateToProps)(Result);
